export const REFERRAL_PARAM = 'za';

export const REFERRAL_SEMINAR = 'radionicu';
